import React from 'react';
import './WhyUsPage.css';

import { PageTitle } from '../../../components';
import { Counter, WhyUs,  Services, Clients, CaseSection, SystemFeatures, CCTVSolutions, Testimonials, Awards } from '../../../sections';



const WhyUsPage = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'Why Choose Us'} page={'Why Choose Us'} />

      <section className='why-choose-us'>

        <SystemFeatures />
        <Counter />
        <CCTVSolutions />
        <Services />
        <WhyUs />
        <CaseSection />
        <Testimonials />
        <Awards />
        <Clients />

      </section>

    </>
  );
}

export default WhyUsPage;